import { FC, MouseEvent } from "react";

import styles from "./styles.module.scss";

interface Props {
    href: string;
    label?: string;
}

const OpenInNewTabLink: FC<Props> = ({
    href,
    label = "Ouvrir le profil dans un nouvel onglet",
}) => {
    const stopRowClick = (event: MouseEvent<HTMLAnchorElement>) => {
        event.stopPropagation();
    };

    return (
        <a
            className={styles.link}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            title={label}
            onClick={stopRowClick}
        >
            <svg
                width="18"
                height="18"
                viewBox="0 0 14 14"
                aria-hidden="true"
                focusable="false"
            >
                <path
                    d="M8 1.5h4.5V6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.5 1.5 6.5 7.5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                />
                <path
                    d="M11 8.2V11a1.5 1.5 0 0 1-1.5 1.5h-6A1.5 1.5 0 0 1 2 11V5a1.5 1.5 0 0 1 1.5-1.5H6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </a>
    );
};

export default OpenInNewTabLink;
